module.exports = __webpack_public_path__ + "img/empty-hint.c1b0df43.svg";